module.exports = __webpack_public_path__ + "img/add.908087de.svg";